import { Observable, Subject } from 'rxjs';
import { Component, OnDestroy, inject } from '@angular/core';

import { DeactivationGuardedComponent } from '@shared/models/component';
import { IIdentity, GridApi } from '@grid/models';
import { UnsavedChangesService } from '@shared/services';
import { UserDetailsFacade } from '@shared/state/facades';

@Component({
  template: '',
})
export abstract class GridPageBaseComponent<T extends IIdentity>
  extends DeactivationGuardedComponent
  implements OnDestroy
{
  gridData$: Observable<T[]>;
  loading$ = new Subject<boolean>();

  gridApi!: GridApi<T>;
  isSaving: boolean;

  protected unsavedChangesService = inject(UnsavedChangesService);

  protected userDetailsFacade = inject(UserDetailsFacade);

  constructor() {
    super();
  }

  //#region Lifecycle hooks

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.unsavedChangesService.unregister();
  }

  //#endregion

  onGridRegistered(gridApi: GridApi<T>): void {
    this.gridApi = gridApi;

    this.unsavedChangesService.register(
      this.save.bind(this),
      this.gridApi.isDirty$
    );
  }

  canDeactivate(): boolean | Observable<boolean> {
    return !this.gridApi?.isDirty();
  }

  //#region Abstract methods

  protected abstract getData(): void;

  //#endregion
}
